
window.ERUrl=path=>{
  path=path.replace(/^#/,'').replace('/collections/all-rx','/collections/prescription-eyewear');
  const guide=path.match(/^\/pages\/(lens-guide|how-to-order|fit-guide)$/);
  if(guide)path='/pages/help-center?guide='+guide[1];
  const root=window.ERTheme.root.replace(/\/$/,'');
  if(root && (path===root || path.startsWith(root+'/')))return path;
  return root+(path.startsWith('/')?path:'/'+path);
};
window.ERApplyCurrentProducts=()=>{
  // Shopify's storefront collection excludes drafts, archived and unlisted products.
  // A missing native product must never survive in the captured catalog.
  const published=new Map((window.ERTheme.products||[]).map(product=>[product.handle,product]));
  window.ER_DATA.products=window.ER_DATA.products.filter(product=>published.has(product.handle));
  for(const collection of window.ER_DATA.collections)collection.handles=collection.handles.filter(handle=>published.has(handle));
  for(const handle of Object.keys(window.ER_DATA.productTitles||{}))if(!published.has(handle))delete window.ER_DATA.productTitles[handle];
  for(const product of window.ER_DATA.products) {
    const actual=published.get(product.handle);
    if(!actual){product.available=false;product.variants.forEach(v=>v.available=false);continue;}
    product.title=actual.title;product.available=actual.available;window.ER_DATA.productTitles[product.handle]=actual.title;
    const currentIds=new Set(actual.variants.map(variant=>String(variant.id)));
    const deletedImages=new Set(product.variants.filter(variant=>!currentIds.has(String(variant.id))).map(variant=>variant.image));
    product.variants=product.variants.filter(variant=>currentIds.has(String(variant.id)));
    const keptImages=new Set(product.variants.map(variant=>variant.image));
    const previousHero=product.images?.[0];
    if(product.images)product.images=product.images.filter(image=>!deletedImages.has(image)||keptImages.has(image));
    if(deletedImages.has(previousHero)&&!keptImages.has(previousHero)&&product.variants[0]){
      const hero=product.variants[0].image;
      product.images=[hero,...product.images.filter(image=>image!==hero)];
    }
    for(const variant of product.variants) {
      const current=actual.variants.find(v=>String(v.id)===String(variant.id));
      variant.price=current.price;variant.available=current.available;variant.compare_at_price=current.compare_at_price;
    }
    product.price=Math.min(...product.variants.map(v=>v.price));
  }
};
window.ERApplyCurrentProducts();
const erGuide=new URLSearchParams(location.search).get('guide');
if(window.ERTheme.path==='/pages/help-center' && ['lens-guide','how-to-order','fit-guide'].includes(erGuide))window.ERTheme.path='/pages/'+erGuide;
